import React from 'react';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function EmptyState2({ title, description, items, link, onItemClick, otherLinkDescription }) {
  // Ensure the onItemClick prop is a function before calling it
  const handleItemClick = (item) => {
    if (onItemClick && typeof onItemClick === 'function') {
      onItemClick(item);
    }
  };

  return (
    <div>
      <h2 className="text-base font-semibold text-gray-900">{title}</h2>
      <p className="mt-1 text-sm text-gray-500">
        {description}
      </p>
      <ul role="list" className="mt-6 grid grid-cols-1 gap-6 border-t border-b border-gray-200 py-6 sm:grid-cols-2">
        {items.map((item, itemIdx) => (
          <li key={itemIdx} className="flow-root">
            <div
              className="relative -m-2 flex items-center space-x-4 rounded-xl p-2 focus-within:ring-2 focus-within:ring-blue-500 hover:bg-gray-50"
              onClick={() => handleItemClick(item)} // Trigger onItemClick with the item
            >
              <div
                className={classNames(item.background, 'flex size-16 shrink-0 items-center justify-center rounded-lg')}
              >
                <item.icon aria-hidden="true" className="size-6 text-white" />
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-900">
                  <a href="#" className="focus:outline-hidden no-underline">
                    <span aria-hidden="true" className="absolute inset-0" />
                    <span>{item.title}</span>
                  </a>
                </h3>
                <p className="mt-1 text-sm text-gray-500">{item.description}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>
          <div className="mt-4 flex">
              <a href="#" onClick={(e) => {
                  e.preventDefault(); // prevent default link behavior
                  link(); // this will call the passed down handleOpenRCMModal function
              }} className="text-sm font-medium text-gray-600 hover:text-gray-500 no-underline">

                  {otherLinkDescription}
              </a>
          </div>
    </div>
  );
}
